import React from 'react';
import styled from 'styled-components';
import { MdInfoOutline } from 'react-icons/md';

const LogoHeader = ({ logoSrc, title, onHelpClick }) => {
    return (
        <LogoContainer>
            <img src={logoSrc} alt={`${title} Logo`} />
        </LogoContainer>
    );
};

const LogoContainer = styled.div`
    text-align: center;
    margin-bottom: 1.25rem;

    img {
        width: 150px;
        margin-bottom: 0.625rem;
    }

    h2 {
        color: ${({ theme }) => theme.colors.brand};
        margin-bottom: 0;
    }
`;

const HelpButton = styled.button`
    background: none;
    border: none;
    color: ${({ theme }) => theme.colors.brand};
    font-size: 1.5rem;
    cursor: pointer;
`;

export default LogoHeader;
